import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import { createMetaManager } from 'vue-meta' // vue-meta-next

const app = createApp(App)

// Create a meta manager instance and provide it
const metaManager = createMetaManager()

app.use(store)
   .use(router)
   .use(metaManager)
   .mount('#app')